<template>
  <v-container fluid>
    <v-layout
      row
      wrap
      justify-center
    >
      <nav-button :route-link="homeRouteLink" />
      <v-btn small :fab="true" @click.native="rotateLayer180">
        <v-icon small>
          fas fa-retweet
        </v-icon>
      </v-btn>

      <LayerPatternComponent
        :box="box"
        :pallet="pallet"
        :initial-box-positions="boxPositions"
        :initial-box-groups="boxGroups"
        :key="layerPatternComponentKey"
        @save="save"
      />
      <v-snackbar
        :value="snackbar.show"
        :color="snackbar.color"
        :timeout="snackbar.timeout"
      >
        {{ snackbar.text }}
        <v-btn
          dark
          flat
          @click.native="snackbar.show = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
import { Pages } from '@/pages'
import NavButton from '@/components/shared/NavButton'
import LayerPatternComponent from '@/components/LayerPatternComponentV2'
import * as layerTransform from '@/libs/layerTransform'

export default {
  name: 'EditLayerPattern',
  components: {
    NavButton,
    LayerPatternComponent
  },

  data: () => ({
    homeRouteLink: Pages.HOME.routeLink,
    snackbar: {
      show: false,
      color: '',
      text: '',
      timeout: 6000
    },
    box: {
      length: 300,
      width: 200,
      // labelPlacement: 'FRONT',
      // labelPlacement: 'FRONT_RIGHT_CORNER',
      // labelPlacement: 'RIGHT',
      // labelPlacement: 'RIGHT_BACK_CORNER',
      // labelPlacement: 'BACK',
      // labelPlacement: 'BACK_LEFT_CORNER',
      // labelPlacement: 'LEFT',
      labelPlacement: 'LEFT_FRONT_CORNER',
      lengthMargin: 5,
      widthMargin: 10
    },
    pallet: {
      palletType: 'EUR',
      length: 1200,
      width: 800,
      overhangL: 10,
      overhangT: 20,
      overhangR: 10,
      overhangB: 20
    },
    boxPositions: [
      { x: 183, y: 266, rotation: 90, id: 1 },
      { x: 984, y: 256, rotation: 0, id: 2 },
      { x: 500, y: 600, rotation: 90, id: 3 },
      { x: 720, y: 600, rotation: 90, id: 4 }
    ],
    boxGroups: [
      [3, 4]
    ],
    layerPatternComponentKey: 0
  }),

  methods: {
    save(updatedBoxPositions, updatedBoxGroups) {
      this.snackbar.show = true
      this.snackbar.color = 'success'
      this.snackbar.text = 'Box positions or groups updated'
      // eslint-disable-next-line
      // console.log(
      //   'Box positions or groups updated! Box positions: ' +
      //     JSON.stringify(updatedBoxPositions) +
      //     ' Box groups: ' +
      //     JSON.stringify(updatedBoxGroups)
      // )
      this.boxPositions = updatedBoxPositions
      this.boxGroups = updatedBoxGroups
    },
    rotateLayer180: function () {
      const newBoxPositions = layerTransform.rotateLayer180(this.pallet, this.boxPositions)
      this.boxPositions = newBoxPositions
      // change the key to force an update
      this.layerPatternComponentKey += 1
      console.log('Rotated box positions: ' + JSON.stringify(this.boxPositions))
    }
  }
}
</script>
